import { useOrderContactInfo } from 'checkout/hooks';
import React from 'react';
import { isValidContactInfo } from 'utilities/validators';
import './UpdateSchibstedAccountInformation.scss';
import { webLogin } from 'user';
export function UpdateSchibstedAccountInformation({ setShouldDisableCheckout }) {
    const orderContactInfo = useOrderContactInfo();
    const contactInfoValid = isValidContactInfo(orderContactInfo);
    const handleWebLoginClick = (e) => {
        e.preventDefault(); // don’t follow the “#” link
        webLogin();
    };
    setShouldDisableCheckout(!contactInfoValid.valid);
    return (React.createElement("div", { className: 'update-schibsted-account-information' }, !contactInfoValid.valid && React.createElement("div", { className: 'update-schibsted-account-information__error' },
        "Du m\u00E5 oppdatere din brukerinfo p\u00E5 ",
        React.createElement("a", { target: "_blank", href: process.env.SPID_PROFILE_PAGE }, process.env.SPID_PROFILE_PAGE),
        " f\u00F8r du kan gjennomf\u00F8re kj\u00F8pet.",
        React.createElement("br", null),
        "N\u00E5r det er gjort, ",
        React.createElement("a", { href: "#", onClick: handleWebLoginClick }, "klikker du her"),
        " for \u00E5 oppdatere din brukerinfo p\u00E5 denne siden.")));
}
